export const lateFilter = (late, row) => {
   return !late.length || (row.late && late.includes('מאוחר') )|| (!row.late && late.includes('רגיל'));
}